import React from "react";
// Make sure this path points to your DealsTable_Component
import DealsTable from "./DealsTable_Component";
import { useAppSelector } from "./hooks/reduxHooks";

/**
 * This tab displays the main deals data using the DealsTable component.
 */
export default function DealsTab(): JSX.Element {
  // Corrected the selector to use the 'results' slice name
  const { deals, status } = useAppSelector((state) => state.resultsSlice);

  // NOTE: The 'loading' status check has been removed from this component.
  // The DealsTable component will now render immediately and is responsible
  // for showing its own loading skeleton.

  // Display an error state if the fetch fails
  if (status === "failed") {
    return (
      <div className="p-4 text-red-500">
        An error occurred while loading deals.
      </div>
    );
  }

  // Display a message if the request succeeded but no deals were returned.
  // We keep this check here so the user sees a clear message instead of just an empty table.
  if (status === "succeeded" && (!deals || deals.length === 0)) {
    return (
      <div className="p-4 text-gray-500">DealOS didn't suggest any relevant deals to highlight in its response.</div>
    );
  }

  // Render the DealsTable. The wrapping div has a little top padding as you specified.
  return (
    <div className="h-full w-full pt-2">
      <DealsTable />
    </div>
  );
}
